import { getCookie } from '../utils/cookie-handler';
import { getCustomerNumber } from '../utils/cookies';

const customerConcertsCookieName = '_bo_customer_concerts';

export function redirectLogin() {
    const queryParams = new URLSearchParams();
    queryParams.append('returnurl', window.location.toString());

    window.location = `${window.AppConfig.blocksOfficeBaseUrl.replace(/^\/|\/$/g, '')}/account/login?${queryParams.toString()}`;
}

export async function applyPromoCode(promoCode) {
    const headers = {
        'Content-type': 'application/x-www-form-urlencoded',
    }

    return fetch(`${window.AppConfig.blocksOfficeBaseUrl.replace(/^\/|\/$/g, '')}/en/promocode/add`, { // eslint-disable-line
        method: 'POST',
        headers: headers,
        credentials: 'include',
        body: new URLSearchParams({ promocode: promoCode }),
    }).then(response => {
        return response.text();
    }).then(response => {
        if (response === 'success') {
            return {
                status: true,
            }
        }

        if (response === 'login') {
            return redirectLogin();
        }

        return { // eslint-disable-line
            status: false,
            message: response,
        }
    }).catch(() => {
        // Other unforseen errors
        return Promise.resolve({  // eslint-disable-line
            status: false,
            message: 'There was an issue applying the promo code. Please check it has been entered correctly.',
        });
    });
}

export async function removePromoCode() {
    return fetch(`${window.AppConfig.blocksOfficeBaseUrl.replace(/^\/|\/$/g, '')}/en/promocode/remove`, { // eslint-disable-line
        method: 'POST',
        credentials: 'include',
    }).then(response => {
        return response.text();
    });
}

export function getCustomerConcerts() {
    const raw = getCookie(customerConcertsCookieName);

    if (!raw) {
        return [];
    }

    let decoded = '';

    try {
        decoded = decodeURIComponent(raw);
    } catch (error) {
        // A malformed cookie shouldn't take the calendar down with it
        return [];
    }

    return decoded.split(',').map(number => {
        return parseInt(number, 10);
    }).filter(number => number);
}

export async function getRecommendedPerformances() {
    const customerNumber = getCustomerNumber() || 0;

    return fetch(`${window.AppConfig.blocksOfficeBaseUrl.replace(/^\/|\/$/g, '')}/api/recommendations/${customerNumber}`, { // eslint-disable-line
        credentials: 'include',
    }).then(response => {
        return response.json();
    });
}

export async function syncArtists() {
    return fetch(`${window.AppConfig.blocksOfficeBaseUrl.replace(/^\/|\/$/g, '')}/api/sync-artists`, { // eslint-disable-line
        credentials: 'include',
    });
}

export default {
    redirectLogin,
    applyPromoCode,
    removePromoCode,
    getCustomerConcerts,
    getRecommendedPerformances,
    syncArtists,
}
